/**
 * Partitions an array into two separate arrays given the callbackFn.
 *
 * ```typescript
 * const nums = [0, 1, 2, 3, 4, 5, 6, 7];
 *
 * const [truths, falsehoods] = partition(nums, v => v % 2 === 0);
 *
 * console.log(truths);     // [0, 2, 4, 6]
 * console.log(falsehoods); // [1, 3, 5, 7]
 * ```
 */
export function partition<E>(
  array: Array<E>,
  callbackFn: (value: E, index?: number, array?: E[]) => boolean
) {
  return array.reduce(
    ([truths, falsehoods], value, index, array) => {
      if (callbackFn(value, index, array)) {
        return [[...truths, value], falsehoods] as const;
      }
      return [truths, [...falsehoods, value]] as const;
    },
    [[], []] as readonly [readonly E[], readonly E[]]
  );
}
